// extracted by mini-css-extract-plugin
export default {"overlay":"Nv-z","bodyOpen":"Ov-z","content":"Pv-z","header":"Qv-z","close":"Rv-z","closeNoHeading":"Sv-z"};